import { render, staticRenderFns } from "./consultingInfo.vue?vue&type=template&id=a4c1fdb6&scoped=true"
import script from "./consultingInfo.vue?vue&type=script&lang=js"
export * from "./consultingInfo.vue?vue&type=script&lang=js"
import style0 from "./consultingInfo.vue?vue&type=style&index=0&id=a4c1fdb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c1fdb6",
  null
  
)

export default component.exports